export default __webpack_public_path__ + "static/P_SearchThumb_TinyCam-aef231ae7a30317842e605827bc1fc44.webp";